import { subscriptionSignalR } from "Services/signalR"


const SignalRPlugin = {
    async install(Vue) {
        const connection =  await subscriptionSignalR()

        Vue.prototype.$connectionSignalR = connection;

        Vue.prototype.$getConnectionId = async function() {
            try {
                const connectionId = await connection.invoke('getConnectionId');
                return connectionId;
            } catch (err) {
                throw err;
            }
        }

    }
}

export default SignalRPlugin